import type {
	Graph,
	GraphModification,
	GraphMetadata,
	KnowledgeObject,
	InstanceWorkspace,
	DescriptorNotification,
} from "@lr-notitia/notitia-operator/schemas";
import { useGraphStore } from "../graph";
import { useDomainStore } from "../domain";
import { useInstanceWorkspacesStore } from "../i-workspace";

let graphStore: ReturnType<typeof useGraphStore>;
let domainStore: ReturnType<typeof useDomainStore>;
let instanceWorkspacesStore: ReturnType<typeof useInstanceWorkspacesStore>;
function init() {
	graphStore = useGraphStore();
	domainStore = useDomainStore();
	instanceWorkspacesStore = useInstanceWorkspacesStore();
}

export function newGraph(): Graph {
	return {
		domainId: "",
		// @ts-ignore
		descriptor: {},
		defaultLanguage: "en",
		languages: [],
		archived: false,
		version: "",
		releasedate: 0,
		releasenotes: "",
		changelog: "",
		dependencies: [],
		hash: "",
		nodes: {},
	};
}

// Explanation:
// currently there is a graph per workspace
// the notitia engine gives back only instances in its GraphModification, so we only need to update instances of the graph.
// other things like descriptors, templates and concepts are considered to stay the same for now. (fetched once in graphStore.loadGraph() on workspace entering )
export function handleGraphModification(nodes: GraphModification, metadata?: GraphMetadata) {
	if (!graphStore || !domainStore || !instanceWorkspacesStore) init();
	if (metadata) graphStore.metadata = metadata;

	function clearInstances() {
		Object.keys(graphStore.graph.nodes).forEach((id) => {
			let oldNode = graphStore.graph.nodes[id] as KnowledgeObject;
			if (oldNode.layer === "instance") {
				delete graphStore.graph.nodes[id];
			}
		});
	}
	function clearDescriptorNotifications() {
		Object.keys(graphStore.graph.nodes).forEach((id) => {
			let oldNode = graphStore.graph.nodes[id];
			if (oldNode.layer === "descriptor" && oldNode.type === "notification") {
				delete graphStore.graph.nodes[id];
			}
		});
	}
	function addNode(node: KnowledgeObject, id: string) {
		if (node.layer === "instance") {
			(graphStore.graph.nodes[id] as KnowledgeObject) = node;
		}
		if (node.layer === "descriptor" && node.type === "notification") {
			graphStore.graph.nodes[id] = node as DescriptorNotification;
		}
	}

	clearInstances();
	clearDescriptorNotifications();
	const ids = Object.keys(nodes);
	ids.forEach((id) => {
		const node = nodes[id];
		if (!node) return;
		addNode(node, id);
	});

	// temporary: handle this manually due to 1 graph per workspace
	// this allows noticing root dataobject changes in a workspace (and other instance-workspace-node changes)
	if (instanceWorkspacesStore.openedWorkspace) {
		let index = instanceWorkspacesStore.workspaces.findIndex(
			(w) => w.id === instanceWorkspacesStore.openedWorkspace?.id,
		);
		if (index == -1) return;
		instanceWorkspacesStore.workspaces[index] = nodes[
			instanceWorkspacesStore.openedWorkspace?.id
		] as InstanceWorkspace;
	}
}
